import type BackOfficeConnector from "../data/backOfficeConnector";
import type { IPagedResults, IPagination } from "../data/types";
import type EventBus from "../services/eventBus";
import RepositoryBase from "./repositoryBase";
import KioskResponse from "entities/kioskResponse";
import type { IListRepository } from "./types";
import { serializeFilters } from "utils/filters";
import type SearchKiosksRequest from "entities/searchKiosksRequest";
import type { EntityValidationRules } from "services/validationService";

export default class KioskRepository extends RepositoryBase<BackOfficeConnector> implements IListRepository<KioskResponse> {
  constructor(protected apiFactory: ReturnType<typeof BackOfficeConnector.Factory>, protected eventBus: EventBus) {
    super(apiFactory, eventBus);
  }
  getAll(
    filters: SearchKiosksRequest,
    pagination: IPagination,
    abortSignal?: AbortSignal
  ): Promise<IPagedResults<KioskResponse>> {
    return this.callApi(
      api =>
        api
          .all("infrastructure")
          .all("kiosk_search")
          .postPagedEntities({ ...serializeFilters(filters, false), ...pagination }, KioskResponse, abortSignal),
      {
        ownApiFactory: () => this.apiFactory({ customVersion: "1.1" }),
      }
    );
  }

  getAllFromSimpleList() {
    return this.callApi(api =>
      api.all("infrastructure").all("simple_lists").all("kiosks").getEntities<KioskResponse>(KioskResponse)
    );
  }
}

export const SearchKiosksValidationRules: EntityValidationRules<SearchKiosksRequest> = {
  name: {
    isLength: {
      max: 255,
      optional: true,
    },
  },
};
